<template lang="">
  <modal-padrao
    ref="modal-input"
    max-width="80%"
    :titulo="
      $t('modulos.modelo_instrumento.modal_adicionar_servico.tituloPeca')
    "
    :titulo-ok="$t('modulos.modelo_instrumento.servico.botoes.adicionar_tipo')"
    :titulo-cancelar="$t('geral.botoes.cancelar')"
    :icone-ok="false"
    @ok="adicionarAoTipo"
  >
    <tabela-padrao-prime-vue
      v-model="selecionados"
      class="mt-2"
      :colunas="tabela.colunas"
      :dados="tabela.dados"
      :filtros-com-colunas="true"
      filtro-global-focus
      :quantidade-itens="tabela.quantidadeItens"
      :por-pagina="tabela.porPagina"
      :quantidade-paginas="tabela.quantidadePaginas"
      :selecionar-apenas-um="true"
      :mostrar-acoes="false"
      @fechar-modal-click-linha="() => $emit('fechar-modal-click-linha')"
      @filtrarGlobal="listar"
      @filtroGlobal="(v) => (filtroAplicado.filter = v)"
      @paginar="listar"
      @nova-ordenacao="ordenacaoColuna"
    />
    <template v-slot:botaoAdicional>
      <botao-padrao color="primary" class="ml-2" @click="adicionarAoModelo()">
        {{
          `${$t('modulos.modelo_instrumento.servico.botoes.adicionar_modelo')}`
        }}
      </botao-padrao>
    </template>
  </modal-padrao>
</template>
<script>
import ServicoInstrumentoService from '@common/services/cadastros/ServicoInstrumentoService';
import helpers from '@/common/utils/helpers';
import _ from 'lodash';
export default {
  props: {
    modeloInstrumentoId: { type: [String, Number], default: null },
    tipoInstrumentoId: { type: String, default: null },
  },
  data() {
    return {
      filtro: {
        nome: '',
      },
      filtroAplicado: { filter: '' },
      selecionados: [],
      tabela: {
        dados: [],
        colunas: [
          {
            value: 'codigo',
            text: this.$t('modulos.modelo_instrumento.servico.tabela.peca'),
            sorteable: true,
          },
          {
            value: 'descricao',
            text: this.$t('modulos.modelo_instrumento.servico.tabela.nome'),
            sorteable: true,
          },
          {
            value: 'participanteFabricante.nome',
            text: this.$t(
              'modulos.modelo_instrumento.servico.tabela.fabricante'
            ),
            sorteable: true,
          },
        ],
        quantidadeItens: 0,
        quantidadePaginas: 0,
        paginaAtual: 1,
        porPagina: 10,
      },
      colunaOrdenada: '',
      parametrosSalvar: {
        itemId: null,
        tipoInstrumentoId: null,
        modeloInstrumentoId: null,
      },
    };
  },
  watch: {
    value: {
      handler() {
        this.selecionados = this.value;
      },
      immediate: true,
    },
    selecionados: {
      handler() {
        if (Array.isArray(this.selecionados)) {
          this.$emit('input', this.selecionados);
          return;
        }
        this.$emit('input', [this.selecionados]);
      },
    },
  },
  methods: {
    abrirModal: function () {
      this.$refs['modal-input'].abrirModal();
      this.listar();
    },
    filtrar: function () {
      this.filtroAplicado = _.cloneDeep(this.filtro);
      this.listar();
    },
    listar: function (
      paginaAtual = this.tabela.paginaAtual,
      porPagina = this.tabela.porPagina
    ) {
      this.tabela.porPagina = porPagina;

      let parametros = {
        page: paginaAtual,
        amountPerPage: porPagina,
        ...helpers.formattingParameters(this.filtroAplicado),
        sort: this.colunaOrdenada,
        modeloInstrumentoId: this.modeloInstrumentoId,
        tipoInstrumentoId: this.tipoInstrumentoId,
      };

      this.$store.dispatch('Layout/iniciarCarregamento');
      this.tabela.dados = [];
      ServicoInstrumentoService.listarPecasModal(parametros)
        .then((res) => {
          this.tabela.dados = res.data.items;
          this.tabela.quantidadeItens =
            res.data.totalItems ?? this.tabela.dados.length;
          this.tabela.quantidadePaginas = res.data.totalPages;
          this.tabela.paginaAtual = paginaAtual;
          this.tabela.porPagina = porPagina;
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    adicionarAoTipo() {
      this.parametrosSalvar.itemId = this.selecionados.id;
      this.parametrosSalvar.tipoInstrumentoId = this.tipoInstrumentoId;

      this.$store.dispatch('Layout/iniciarCarregamento');
      ServicoInstrumentoService.salvarPecas(this.parametrosSalvar)
        .then(() => {
          this.toastSucesso(
            this.$t(
              `modulos.modelo_instrumento.servico.adicionado_tipo_sucesso`
            )
          );
        })
        .catch(() => {
          this.toastErro(
            this.$t(`modulos.modelo_instrumento.servico.erros.adicionar_tipo`)
          );
        })
        .finally(() => {
          this.parametrosSalvar = {};
          this.closeModal();
          this.$emit('atualizar-pagina');
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    adicionarAoModelo() {
      this.parametrosSalvar.itemId = this.selecionados.id;
      this.parametrosSalvar.tipoInstrumentoId = this.tipoInstrumentoId;
      this.parametrosSalvar.modeloInstrumentoId = this.modeloInstrumentoId;

      this.$store.dispatch('Layout/iniciarCarregamento');
      ServicoInstrumentoService.salvarPecas(this.parametrosSalvar)
        .then(() => {
          this.toastSucesso(
            this.$t(
              `modulos.modelo_instrumento.servico.adicionado_modelo_sucesso`
            )
          );
        })
        .catch(() => {
          this.toastErro(
            this.$t(`modulos.modelo_instrumento.servico.erros.adicionar_modelo`)
          );
        })
        .finally(() => {
          this.parametrosSalvar = {};
          this.closeModal();
          this.$emit('atualizar-pagina');
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    closeModal() {
      this.$refs['modal-input'].fecharModal();
    },
    ordenacaoColuna(ordem) {
      this.colunaOrdenada = ordem;
      this.listarRegistros();
    },
    MontarViewColunasItens(lista_dados) {
      return {
        value: lista_dados?.map((v) => {
          return { nome: v?.nome };
        }),
      };
    },
    faixaFormatada(value) {
      return String(value).replaceAll('.', ',');
    },
  },
};
</script>
